import { Typeahead, Menu, MenuItem } from "react-bootstrap-typeahead";
import { Card, CardBody, Col, Form } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { MULTIPLE_SECTIONS_WITH_HEADERS, MULTI_WITH_HEADER } from "../../../../Data/FormWidgets";
import { MultipleSectionWithHeader } from "../../../../Constant";

const MultipleSectionsWithHeaders = () => {
  const renderMenu = (results: any[], menuProps: any) => {
    const items = results.map((result, index) => {
      if (result.divider === true) {
        return <li key={index} role="separator" className="divider" />;
      }
      if (result.header === true) {
        return (
          <li key={index} className="dropdown-header">{result.name}</li>
        );
      }
      return (
        <MenuItem key={index} option={result} position={index}>
          <strong>{result.name}</strong>
          <div>{result.description}</div>
        </MenuItem>
      );
    });
    return <Menu {...menuProps}>{items}</Menu>;
  };

  return (
    <Col sm="12" md="6">
      <Card>
        <CommonCardHeader  title={MultipleSectionWithHeader} span={MULTIPLE_SECTIONS_WITH_HEADERS}/>
        <CardBody>
          <div id="multiple-datasets">
            <Form className="theme-form">
              <div>
                <Typeahead options={MULTI_WITH_HEADER} placeholder="NBA and NHL teams" renderMenu={renderMenu} id="Multiple Sections With Headers" />
              </div>
            </Form>
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default MultipleSectionsWithHeaders;
